import { render, staticRenderFns } from "./CustomTaxIdField.vue?vue&type=template&id=acd3b27e"
import script from "./CustomTaxIdField.vue?vue&type=script&lang=ts"
export * from "./CustomTaxIdField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports